import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
  Typography,
  Divider,
  Card,
  Avatar,
  Space,
} from "antd";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import Jiggle from "@assets/KPMG/Jiggle.svg";
import Symtric from "@assets/KPMG/Symtric.svg";
import WishHelp from "@assets/KPMG/WishHelp.svg";
import Resecurb from "@assets/KPMG/Resecurb.svg";
import Welytics from "@assets/KPMG/Welytics.svg";
import oracle from "@assets/KPMG/oracle.svg";
import Morphus from "@assets/KPMG/Morphus.svg";
import styles from "../Team/Team.module.scss";
import { Icon } from "@iconify/react";
import { Navigation, Pagination, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Title } from "../Title/Title";
import { Fade } from "react-awesome-reveal";

const LogoGallery = (props: any) => {
  const { element, fullWidth } = props;
  const logos = [
    // Add your logo image URLs here
    Jiggle,
    Symtric,
    WishHelp,
    Resecurb,
    Welytics,
    oracle,
    Morphus,
  ];
  const cardsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(logos.length);
  const [visibleData, setVisibleData] = useState<any>([]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * cardsPerPage;
    const endIndex = startIndex + cardsPerPage;
    const currentData = logos.slice(startIndex, endIndex);
    setVisibleData(currentData);
  }, [currentPage]);

  return (
    <>
      <Divider />
      <Fade direction="right" triggerOnce>
        <Row className="meet-our-team">
          {!fullWidth && <Col md={2}></Col>}

          <Col
            md={2}
            style={{
              display: "flex",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            {element}
          </Col>
          <Col md={!fullWidth ? 18 : 22}>
            <Row
              gutter={[16, 16]}
              justify="center"
              align="middle"
              style={{ padding: "20px 0" }}
            >
              <Swiper
                // install Swiper modules
                modules={[Navigation, Pagination, A11y, Autoplay]}
                spaceBetween={50}
                slidesPerView={5}
                navigation
                // pagination={{ clickable: true }}
                scrollbar={{ draggable: true }}
                autoplay={{ delay: 4000, pauseOnMouseEnter: true }}
                // loop={true}
                // loopedSlides={4}
                // onSwiper={(swiper) => console.log(swiper)}
                // onSlideChange={() => console.log("slide change")}
              >
                {logos.map((data: any, index: any) => (
                  <SwiperSlide key={index}>
                    <Col
                      span={4}
                      key={data.id}
                      style={{
                        transition: "transform 0.5s",
                        display: "flex",
                        justifyContent: "center",
                        minWidth: "210px",
                      }}
                    >
                      <Col key={index}>
                        <img
                          src={data}
                          alt={`Logo ${index + 1}`}
                          style={{ maxWidth: "100%", height: "auto" }}
                        />
                      </Col>
                    </Col>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Row>
          </Col>
          {!fullWidth && <Col md={2}></Col>}
        </Row>
      </Fade>
      <Divider />
    </>
  );
};

export default LogoGallery;
